import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes';
import { ConfigProvider, theme } from 'antd';
import { checkApiHealthPlanet } from './externalAPI/planetAPI';
import { checkApiHealthMinka } from './externalAPI/minkaAPI';
import './css/App.css';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './components/auth/keycloak';

const { compactAlgorithm } = theme;

const App: React.FC = () => {
  useEffect(() => {
    // Define an async function to check the API status
    const checkApiStatus = async () => {
      try {
        // Wait for both API checks to complete
        const planetApiStatus = await checkApiHealthPlanet();
        const minkaApiStatus = await checkApiHealthMinka();
        // Format the output in a cleaner way
        const apiStatus = [
          'API Status:',
          `Planet: ${planetApiStatus ? 'Up' : 'Down'}`,
          `Minka: ${minkaApiStatus ? 'Up' : 'Down'}`,
        ].join('\n');
        // Log the API status
      } catch (error) {
        console.error('Error checking API statuses:', error);
      }
    };

    // Call the async function to check the APIs
    // checkApiStatus();
  }, []);
  const eventLogger = (event: any, error?: any) => {
    // You can add more specific logic here to handle different events
    if (event === 'onAuthError' || event === 'onReady') {
      // You could check the status of your Keycloak instance here
      // and log a connection or disconnection status
    }
  };

  const tokenLogger = (tokens: any) => {
    // This event is triggered on token refresh, which can be an indicator of a healthy connection
  };

  return (
    <ConfigProvider
      theme={{
        algorithm: compactAlgorithm,
        token: {
          colorPrimary: '#0e0e0e',
          fontSize: 16,
          borderRadius: 14,
        },
      }}
    >
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={{ onLoad: 'login-required' }}
        onEvent={eventLogger}
        onTokens={tokenLogger}
      >
        <Router>
          <Routes />
        </Router>
      </ReactKeycloakProvider>
    </ConfigProvider>
  );
};

export default App;
